import { useState } from "react";
import { DateTime } from "luxon";
import moment from "moment";

import { REGIONAL_TIMEZONES } from "../constants";

export const getOffset = (zone: string) =>
	DateTime.local().setZone(zone).toFormat("ZZ");

export const useTimezoneStoreMethods = () => ({
	getTimezone: localStorage.getItem.bind(localStorage, "timezone"),
	updateTimezone: localStorage.setItem.bind(localStorage, "timezone"),
});

export const useTimezoneOperations = () => {
	const { getTimezone, updateTimezone } = useTimezoneStoreMethods();
	const [timezone, setTimezone] = useState<string>(getTimezone() || "");

	const _updateTimezone = (value: string) => {
		updateTimezone(value);
		setTimezone(value);
	};

	return {
		setTimezone: _updateTimezone,
		timezone,
	};
};

export const useGetConvertedUserTime = (
	utcTime: string,
	mask = "yyyy-MM-dd HH:mm:ss"
) => {
	const { timezone } = useTimezoneOperations();

	if (!REGIONAL_TIMEZONES.includes(timezone) || !utcTime || utcTime === "")
		return utcTime;
	return DateTime.fromFormat(
		moment(utcTime).format("yyyy-MM-DD HH:mm:ss"),
		mask,
		{
			zone: "UTC",
		}
	)
		.setZone(`UTC${getOffset(timezone)}`)
		.toFormat(mask);
};
